<template lang="pug">
.bloco-regularizacao
    .bloco-regularizacao__titulo
        .bloco-regularizacao__titulo--interno
            span Total de Imóveis:
            span.negrito {{ imoveisValor }}

    .bloco-regularizacao__conteudo
        .bloco-regularizacao__conteudo--esquerdo
            span.barra-topo Área total dos imóveis passíveis de regularização
            span.valor__negrito {{ areaValor }}

    .bloco-regularizacao__alinhamento
        .bloco-regularizacao__alinhamento--conteudo
            span.barra-topo Déficit de Reserva Legal
            span.valor__negrito {{ reservaLegal }}
        .bloco-regularizacao__alinhamento--conteudo
            span.barra-topo Déficit de APP
            span.valor__negrito {{ deficitApp }}
        .bloco-regularizacao__alinhamento--conteudo
            span.barra-topo Déficit de Vegetação Nativa
            span.valor__negrito {{ deficitVegetacao }}
</template>

<script>
export default {
    name: 'BlocoRegularizacao',
    props: {
        imoveisValor: {
            type: String,
            default: () => ''
        },
        areaValor: {
            type: String,
            default: () => ''
        },
        reservaLegal: {
            type: String,
            default: () => ''
        },
        deficitApp: {
            type: String,
            default: () => ''
        },
        deficitVegetacao: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.bloco-regularizacao {
    width: 100%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 10px 20px;
    flex-direction: column;
    height: 405px;
    .bloco-regularizacao__titulo {
        display: flex;
        padding-bottom: 8px;
    }
    .bloco-regularizacao__titulo--interno {
        font-size: 14px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        width: 80%;
        .negrito {
            font-weight: 600;
            font-size: 20px;
            color: var(--primary);
        }
    }
    .bloco-regularizacao__conteudo {
        display: flex;
        margin-bottom: 15px;
        &--esquerdo {
            display: flex;
            flex-direction: column;
            min-width: 58%;
        }
        &--direito {
            display: flex;
            flex-direction: column;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .bloco-regularizacao__alinhamento {
        display: flex;
        flex-direction: column;

        &--conteudo {
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .barra-topo::before {
        content: '';
        display: flex;
        width: 24px;
        height: 2px;
        background: var(--secondary-two);
        clear: both;
        margin-bottom: 5px;
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
</style>
